import { Link } from "react-router-dom";
import { UnderConstruction } from "./UnderConstruction";
//import founderPic from "./../assets/img/founder-total-solar-1_2.png"
import { useEffect, useRef } from "react";
import { CommonTransition } from "../utils/CommonTransition";
import { useIsInViewport } from "../utils/CustomHooks";
import { ASSETS_URL } from "../utils/constants";

const founderPic = ASSETS_URL + 'founder-total-solar-1_2.png'

const TextLeftParagraph = ({className, children}) => <>
  <p className={`m-2 w-full text-left ${className}`}>{children}</p>
</>

const YellowLink = ({to, className, children}) => <>
  <Link className={`hover:underline text-[#9aed79] ${className}`} to={to}>{children}</Link>
</> 
function About() {
    const containerRef = useRef(null)

    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" })
      }
    }, [containerRef])
    return (
      <div ref={containerRef} className="w-[80%] bg-[#212121] text-[#f7f7f7] flex flex-col justify-center items-center my-10">
        <Mission />

        <Vision />
        <iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F100085341354458%2Fvideos%2F797465305155505%2F&show_text=false&width=560&t=0" width="800" height="600" className='border-0 overflow-hidden' allow="autoplay clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen={true} />

        <TextLeftParagraph>At Total Solar Installation, we take pride in our commitment to innovation and cutting-edge technology. We stay at the forefront of the solar industry, consistently researching and implementing the latest advancements to offer our customers the most efficient and cost-effective solutions. We understand that every home, business, and community has unique energy needs. That's why we offer a wide range of <YellowLink to={'/projects'}>customizable solar solutions</YellowLink> to suit any requirement. Whether you are looking for a residential solar system to power your home or a commercial-scale installation for your business, we have the expertise to design, install, and maintain a solar energy system tailored specifically for your needs.</TextLeftParagraph> 

        <TextLeftParagraph>We believe in transparent communication and will ensure you have a full understanding of your solar energy system's benefits, performance, and long-term savings. By reducing your reliance on traditional power sources, you will not only significantly lower your electricity bills but also make a positive impact on the environment. Investing in solar energy is a smart financial decision that will pay dividends for years to come.</TextLeftParagraph>

        <TextLeftParagraph>Join us on our mission to create a cleaner, more sustainable future. Discover the power of solar energy with Total Solar Installation.</TextLeftParagraph>

        <TextLeftParagraph><YellowLink to={'/contact'}>Contact us today</YellowLink> for a personal consultation or <YellowLink to={'/products'}>explore our website</YellowLink> to learn more about our services and the benefits of going solar.</TextLeftParagraph> 

        <TextLeftParagraph>Together, let's embrace the sun and unlock the full potential of renewable energy.</TextLeftParagraph>

        <TextLeftParagraph className={'font-extrabold text-xl mt-10 text-[#4CB117]'}>MEET OUR CEO</TextLeftParagraph>
        <div className="flex items-center">
          <img src={founderPic} alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel in the philippines'" className="object-contain h-[150px] w-[150px] rounded-full"/>
          <div>
          <TextLeftParagraph className={'mb-0'}>Engr. Ronmar B. Gonzales is a Professional Electrical Engineer, Registered Master Plumber, a Mechanical Engineer, and a Certified Energy Manager. </TextLeftParagraph>
          <TextLeftParagraph className={'mt-0'}>He has 14 years experience of Electrical Design, Construction, and Operation of a high rise commercial, financial, institutional, resiredential, ship establishments.</TextLeftParagraph>
          <TextLeftParagraph><YellowLink to={'/team'}>Know more about our CEO and Total Solar Installation Team!</YellowLink></TextLeftParagraph>
          </div>
          
        </div>
        

      </div>
    );
  }
  
  export default About;

  export const Mission = () => {
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)
    return <>
    <div ref={containerRef} className="w-full flex flex-row items-center my-3">
      <CommonTransition open={isInViewport} durationEnter={'duration-[2000ms]'} enterFrom={'translate-x-full'} enterTo={'text-[#9aed79]'}>
          <div className="text-base sm:text-7xl font-extrabold p-3 break-all sm:break-normal text-center">MISSION</div>
      </CommonTransition>
      <CommonTransition open={isInViewport} durationEnter={'delay-[1000ms] duration-[1000ms]'}>
          <div className="p-3 text-sm sm:text-base text-left">To provide accessible and sustainable solar solutions that enable individuals and businesses to embrace renewable energy, reduce their carbon footprint, and contribute to a greener future.</div>
      </CommonTransition>
    </div>
    </>
  }

  export const Vision = () => {
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)
    return <>
    <div ref={containerRef} className="w-full flex flex-row-reverse items-center my-3">
      <CommonTransition open={isInViewport} durationEnter={'duration-[2000ms]'} enterFrom={'-translate-x-full'} enterTo={'text-[#9aed79]'}>
          <div className="text-base sm:text-7xl font-extrabold p-3 break-all sm:break-keep text-center">VISION</div>
      </CommonTransition>
      <CommonTransition open={isInViewport} durationEnter={'delay-[1000ms] duration-[1000ms]'}>
        <div className="p-3 text-sm sm:text-base text-right">
          <div>To be the leading provider and installer of solar panel solutions in the Philippines, recognized for our excellent quality, customer-centric approach, and commitment to driving the adoption of clean energy solutions. </div>
        </div>
      </CommonTransition>
    </div>
    </>
  }